import { render } from "./express.vue?vue&type=template&id=d1c66590&scoped=true&ts=true"
import script from "./express.vue?vue&type=script&lang=ts"
export * from "./express.vue?vue&type=script&lang=ts"

import "./express.vue?vue&type=style&index=0&id=d1c66590&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c66590"]])

export default __exports__